/* GLDN – automatyczny darmowy Scrunchies 3-pack od 300 zł PRZED rabatami.
   Działa w koszyku wysuwanym Minimog i na stronie /cart.
   Kod WELCOMEGLDN i inne rabaty mogą łączyć się z prezentem,
   jeśli pozwalają na to ustawienia rabatów w Shopify. */

(() => {
  const ROOT = window.Shopify?.routes?.root || '/';
  const GIFT_HANDLE = 'scrunchies-3-pack';
  const GIFT_PROPERTY = '_gldn_free_3pack';
  const THRESHOLD = 30000; // grosze

  let timer;
  let revision = 0;
  let processing = false;
  let giftPromise;
  let lastAutoAttemptSignature = null;

  const isCartPage = () =>
    /(?:^|\/)cart\/?$/.test(location.pathname);

  const cartBody = () => document.getElementById(
    isCartPage() ? 'MinimogCartBody' : 'MinimogCartDrawerBody'
  );

  function ensurePageHost() {
    if (!isCartPage()) return;

    const body = cartBody();

    if (!body || body.querySelector('#gldn-cart-gift-page')) {
      return;
    }

    const box = document.createElement('div');
    box.id = 'gldn-cart-gift-page';
    box.hidden = true;
    body.append(box);
  }

  const host = () => document.getElementById(
    isCartPage() ? 'gldn-cart-gift-page' : 'gldn-cart-gift'
  );

  const money = cents => new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN'
  }).format(Number(cents || 0) / 100);

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(render, 150);
  }

  async function getCart() {
    const res = await fetch(`${ROOT}cart.js`, {
      cache: 'no-store'
    });

    if (!res.ok) {
      throw new Error('Nie udało się pobrać koszyka.');
    }

    return res.json();
  }

  async function getGiftProduct() {
    if (!giftPromise) {
      giftPromise = fetch(
        `${ROOT}products/${GIFT_HANDLE}.js`
      )
        .then(res => {
          if (!res.ok) {
            throw new Error(
              'Nie znaleziono Scrunchies 3-pack.'
            );
          }

          return res.json();
        })
        .catch(error => {
          giftPromise = null;
          throw error;
        });
    }

    return giftPromise;
  }

  /* ========================================
     PRÓG 300 ZŁ PRZED RABATAMI
     ======================================== */

  function qualifiedValue(cart) {
    return (cart.items || []).reduce((total, item) => {
      // Nie uwzględniaj kart podarunkowych
      if (item.gift_card === true) return total;

      // Nie uwzględniaj darmowego 3-paku
      if (item.properties?._gldn_free_3pack === '1') {
        return total;
      }

      // Wszystkie pozostałe produkty, przed rabatami
      return total + Number(item.original_line_price || 0);
    }, 0);
  }

  /* Rozpoznawanie prezentu dodanego przez GLDN */

  function isOurGift(item) {
    return (
      item.handle === GIFT_HANDLE &&
      String(
        item.properties?.[GIFT_PROPERTY] || ''
      ) === '1'
    );
  }

  /* Każdy konkretny stan koszyka wyzwala najwyżej jedną
     automatyczną próbę dodania. Dzięki temu brak łączenia
     rabatów nie powoduje pętli dodawania i usuwania gratisu. */

  function cartSignature(cart) {
    return JSON.stringify(
      (cart.items || [])
        .filter(item => !isOurGift(item))
        .map(item => [
          item.key,
          item.quantity,
          item.original_line_price,
          item.final_line_price
        ])
    );
  }

  /* ========================================
     SHOPIFY CART API
     ======================================== */

  async function changeCart(endpoint, data) {
    const res = await fetch(`${ROOT}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
      const error = await res.json().catch(() => ({}));

      throw new Error(
        error.description ||
        error.message ||
        'Błąd koszyka.'
      );
    }

    return res.json();
  }

  /* ========================================
     ODŚWIEŻANIE KOSZYKA MINIMOG
     ======================================== */

  async function refreshMinimog() {
    const body = cartBody();

    if (typeof body?.onCartRefresh === 'function') {
      await body.onCartRefresh({
        detail: { open: false }
      });
    } else {
      document.dispatchEvent(
        new CustomEvent('cart:refresh', {
          detail: { open: false }
        })
      );
    }
  }

  async function removeGift(item) {
    await changeCart('cart/change.js', {
      id: item.key,
      quantity: 0
    });
  }

  function hideBox(box) {
    if (!box) return;

    box.hidden = true;
    box.replaceChildren();
  }

  /* ========================================
     BUDOWANIE SEKCJI PREZENTU
     ======================================== */

  function buildGiftBox(box, product) {
    const variants = (product.variants || [])
      .filter(v => v.available);

    const heading = document.createElement('h4');
    heading.className = 'gldn-cart-gift__heading';
    heading.textContent = 'TWÓJ DARMOWY PREZENT';

    const row = document.createElement('div');
    row.className = 'gldn-cart-gift__row';

    const photo = document.createElement('img');
    photo.className = 'gldn-cart-gift__photo';
    photo.src = product.featured_image || '';
    photo.alt = product.title;
    photo.loading = 'lazy';

    const info = document.createElement('div');
    info.className = 'gldn-cart-gift__info';

    const title = document.createElement('strong');
    title.textContent = product.title;

    const prices = document.createElement('div');
    prices.className = 'gldn-cart-gift__prices';

    const oldPrice = document.createElement('s');
    oldPrice.textContent = money(
      variants[0]?.price ?? product.price ?? 0
    );

    const gratis = document.createElement('strong');
    gratis.textContent = 'GRATIS';

    prices.append(oldPrice, gratis);
    info.append(title, prices);

    /* Wybór wariantu, jeśli produkt ma ich kilka */

    if (variants.length > 1) {
      const select = document.createElement('select');
      select.className = 'gldn-cart-gift__variant';

      select.setAttribute(
        'aria-label',
        'Wybierz wariant darmowego 3-paku'
      );

      variants.forEach(v => {
        select.add(
          new Option(v.title, String(v.id))
        );
      });

      info.append(select);
    }

    /* Przycisk odbioru */

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'gldn-cart-gift__add';

    button.textContent = variants.length
      ? 'ODBIERZ GRATIS'
      : 'CHWILOWO NIEDOSTĘPNY';

    button.disabled = !variants.length;

    info.append(button);
    row.append(photo, info);

    /* Informacja o promocji */

    const note = document.createElement('p');
    note.className = 'gldn-cart-gift__note';

    note.textContent =
      'Darmowy 3-pak przy zakupach od 300 zł przed rabatami.';

    box.replaceChildren(heading, row, note);
    box.hidden = false;
  }

  /* ========================================
     SPRAWDZANIE UPRAWNIEŃ DO PREZENTU
     ======================================== */

  async function render() {
    if (processing) return;

    ensurePageHost();

    const box = host();
    if (!box) return;

    const request = ++revision;

    try {
      const cart = await getCart();

      if (
        processing ||
        request !== revision ||
        !box.isConnected
      ) return;

      const value = qualifiedValue(cart);
      const marked = (cart.items || []).find(isOurGift);

      /* Usuń prezent, jeśli:
         - produkty spadły poniżej 300 zł,
         - Shopify przestał naliczać 100% rabatu. */

      if (
        marked &&
        (
          value < THRESHOLD ||
          Number(marked.final_line_price) !== 0
        )
      ) {
        processing = true;
        hideBox(box);

        try {
          await removeGift(marked);
          await refreshMinimog();
        } catch (error) {
          console.error(
            'GLDN – nie udało się usunąć prezentu:',
            error
          );
        } finally {
          processing = false;
          schedule();
        }

        return;
      }

      /* Maksymalnie jedna sztuka gratisu */

      if (marked && marked.quantity > 1) {
        processing = true;

        try {
          await changeCart('cart/change.js', {
            id: marked.key,
            quantity: 1
          });

          await refreshMinimog();
        } catch (error) {
          console.error(
            'GLDN – korekta ilości prezentu:',
            error
          );
        } finally {
          processing = false;
          schedule();
        }

        return;
      }

      /* Nie pokazuj prezentu, gdy:
         - produkty są poniżej 300 zł przed rabatem,
         - Scrunchies 3-pack jest już w koszyku. */

      if (
        value < THRESHOLD ||
        (cart.items || []).some(
          item => item.handle === GIFT_HANDLE
        )
      ) {
        if (value < THRESHOLD) {
          lastAutoAttemptSignature = null;
        }
        hideBox(box);
        return;
      }

      const product = await getGiftProduct();

      if (
        processing ||
        request !== revision ||
        !box.isConnected
      ) return;

      buildGiftBox(box, product);

      /* Dodawaj automatycznie po osiągnięciu progu. Przycisk
         zostaje awaryjnie dostępny, jeśli automatyczna próba
         się nie powiedzie (np. przez konflikt rabatów). */

      const signature = cartSignature(cart);

      if (lastAutoAttemptSignature !== signature) {
        const button = box.querySelector(
          '.gldn-cart-gift__add'
        );

        if (button && !button.disabled) {
          lastAutoAttemptSignature = signature;
          void claim(button, true);
        }
      }

    } catch (error) {
      console.warn(
        'GLDN – wyświetlanie prezentu:',
        error
      );

      if (request === revision) {
        hideBox(box);
      }
    }
  }

  /* ========================================
     ODBIÓR DARMOWEGO PREZENTU
     ======================================== */

  async function claim(button, automatic = false) {
    if (processing || button.disabled) return;

    processing = true;
    button.disabled = true;
    button.textContent = 'DODAWANIE…';

    let added = false;

    try {
      const before = await getCart();

      if (
        qualifiedValue(before) < THRESHOLD ||
        before.items.some(
          item => item.handle === GIFT_HANDLE
        )
      ) {
        throw new Error(
          'Koszyk nie spełnia już warunków promocji.'
        );
      }

      const product = await getGiftProduct();

      const available = (product.variants || [])
        .filter(v => v.available);

      const select = host()?.querySelector(
        '.gldn-cart-gift__variant'
      );

      const variantId = select
        ? Number(select.value)
        : Number(available[0]?.id);

      if (
        !variantId ||
        !available.some(
          v => Number(v.id) === variantId
        )
      ) {
        throw new Error(
          'Prezent jest obecnie niedostępny.'
        );
      }

      /* Dodaj normalny produkt Shopify */

      await changeCart('cart/add.js', {
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            [GIFT_PROPERTY]: '1'
          }
        }]
      });

      added = true;

      /* Sprawdź, czy Shopify naliczył 100% rabatu */

      const after = await getCart();
      const gift = after.items.find(isOurGift);

      if (
        !gift ||
        Number(gift.final_line_price) !== 0 ||
        qualifiedValue(after) < THRESHOLD
      ) {
        throw new Error(
          'Shopify nie naliczył darmowego 3-paku. ' +
          'Sprawdź łączenie rabatów.'
        );
      }

      await refreshMinimog();

    } catch (error) {
      console.warn(
        'GLDN – dodawanie gratisu:',
        error
      );

      /* Wycofaj prezent, jeśli nie został
         prawidłowo objęty rabatem. */

      if (added) {
        try {
          const cart = await getCart();
          const gift = cart.items.find(isOurGift);

          if (gift) {
            await removeGift(gift);
          }
        } catch (rollbackError) {
          console.error(
            'GLDN – wycofanie gratisu:',
            rollbackError
          );
        }
      }

      try {
        await refreshMinimog();
      } catch (_) {}

      if (!automatic) {
        window.alert(error.message);
      }

    } finally {
      processing = false;
      schedule();
    }
  }

  /* ========================================
     INICJALIZACJA
     ======================================== */

  function start() {
    const body = cartBody();
    if (!body) return;

    ensurePageHost();

    /* Usunięcie starej klasy blokującej prezent
       po użyciu kodu rabatowego. */

    document.body.classList.remove(
      'gldn-gift-code-active'
    );

    /* Aktualizacje zawartości koszyka */

    new MutationObserver(() => {
      ensurePageHost();
      schedule();
    }).observe(body, {
      childList: true
    });

    document.addEventListener(
      'cart:updated',
      schedule
    );

    /* Kliknięcie ODBIERZ GRATIS */

    document.addEventListener('click', event => {
      const target = event.target instanceof Element
        ? event.target
        : null;

      const button = target?.closest(
        '.gldn-cart-gift__add'
      );

      if (
        button &&
        host()?.contains(button)
      ) {
        void claim(button);
      }
    });

    /* Odświeżenie po otwarciu Cart Drawer */

    if (!isCartPage()) {
      const drawer = document.getElementById(
        'MinimogCartDrawer'
      );

      if (drawer) {
        new MutationObserver(() => {
          if (
            drawer.classList.contains(
              'm-cart-drawer--active'
            )
          ) {
            schedule();
          }
        }).observe(drawer, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    }

    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();